/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-05-26 23:49:06
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import { SubmissionError } from 'redux-form';

/**
 * Build initial values for redux form
 *
 * @param  {object} metafield
 *
 * @return {object}           redux form for metafield
 */
export const buildInitialValues = metafield => {
  // Initial value form with new value
  let initialValues = {
    namespace: '',
    key: '',
    appliesTo: {
      search: false,
      filterOption: false,
      display: true,
      sortByOption: true
    }
  };

  if (!_.isEmpty(metafield)) {
    const { namespace, key, appliesTo = {} } = metafield;
    appliesTo.display = appliesTo.display || true;
    initialValues = { ...initialValues, namespace, key, appliesTo };
  }

  return initialValues;
};

/**
 * Validate metafield
 *
 * @param  {object} metafield
 * @return {boolean}           true | false
 */
export const validateBeforeSave = (metafield, i18n) => {
  // Implement validation before saving if needed
  const { namespace, key } = metafield;
  if (/<[^ >]+>/g.test(namespace)) {
    throw new SubmissionError({
      namespace: i18n.translate('AdminHTML.Metafield.Validate.invalid_Namespace_SpecialCharacter')
    });
  }
  if (/<[^ >]+>/g.test(key)) {
    throw new SubmissionError({
      key: i18n.translate('AdminHTML.Metafield.Validate.invalid_Key_SpecialCharacter')
    });
  }
  return true;
};

/**
 * Build metafield value for saving
 *
 * @param  {object} metafield
 * @return {object}           updated metafield
 */
export const buildMetafield = metafield => {
  metafield.type = 'metafield_custom_single_metafield';

  return metafield;
};

/**
 * Get invalid metafields
 *
 * @param  {object} metafields            list of metafield config
 * @param  {object} metafieldOptionValues list of metafield values
 * @param  {number} lastSyncDoneAt
 * @param  {number} lastSyncDuration
 *
 * @return {array}                        list of invalid metafield
 */
export const getInvalidMetafields = (
  metafields,
  metafieldOptionValues,
  lastSyncDoneAt,
  lastSyncDuration
) => {
  const invalid = [];
  const now = Math.round(Date.now() / 1000);
  metafields.forEach(metafield => {
    // Get namespace, key and updatedAt
    // Note: if the updatedAt is undefined, set default value is lastSyncDoneAt
    // to mark that the metafield values are synced from last sync. This value
    // is used to check the validation of metafield
    const { namespace, key, updatedAt = lastSyncDoneAt } = metafield;
    const type = `metafield::${namespace}::${key}`;

    // Invalid if empty values and the sync is finished when compared with updated time
    if (
      _.isEmpty(_.get(metafieldOptionValues, type, [])) &&
      updatedAt + 180 + lastSyncDuration < now
    ) {
      invalid.push({ namespace, key });
    }
  });

  return invalid;
};
